<template>
  <div>
    <add-or-update-common-complaints-modal
      :is-add-active.sync="toggleModal"
      @refetchData="fetchCommonComplaints"
    />

    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="values" 
        :loading="loading"
        :close-on-select="false"
        :reduce="val => val.id" 
        :options="common_complaints" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name" 
        multiple 
        clearable 
        @input="val => $emit('change', val)"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Click on icon refresh</div>

            <b-button size="sm" variant="no-outline" @click="fetchCommonComplaints">
              <feather-icon icon="RefreshCcwIcon" size="16" color="dodgerblue"></feather-icon>
            </b-button>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>

      <div v-if="can('common_complaints:CanAddNew')">
        <b-button size="sm" variant="no-outline" @click="onAddNew">
          <feather-icon icon="PlusCircleIcon" size="25" color="dodgerblue"></feather-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddOrUpdateCommonComplaintsModal from '@/@core/components/shared/admin/modals/AddOrUpdateCommonComplaintsModal.vue';

export default {
  components: {
    vSelect,
    BButton,

    AddOrUpdateCommonComplaintsModal
  },
  props: {
    values: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,
      common_complaints: [],
    }
  },
  created() {
    this.fetchCommonComplaints();
  },
  methods: {
    async fetchCommonComplaints() {
      try {
        this.loading = true; 

        const query = {
          page: 1,
          limit: 1000,
        }

        const request = await this.useJwt().mainService.commonComplaints.list(query);
        const { data } = request.data;
        this.common_complaints = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onAddNew(){
      this.toggleModal = true;
    },
  }
}
</script>
